import {
  queryOptions,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import {
  getDistributorBranding,
  updateDistributorBranding,
} from "../../api/distributor/profile";

export const getDistributorBrandingOptions = (enabled = true) =>
  queryOptions({
    queryKey: ["distributor-branding"],
    queryFn: getDistributorBranding,
    enabled,
  });

export function useDistributorBranding(enabled = true) {
  return useQuery(getDistributorBrandingOptions(enabled));
}

export function useUpdateDistributorBranding() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateDistributorBranding,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["distributor-branding"] });
    },
  });
}
